<template>
  <v-card class="pa-5">
    <v-row class="d-flex justify-space-between align-center">
      <v-col class="title d-flex align-center">
        <v-row>
          <v-col cols="12">
            <span class="text-md-h5 font-weight-bold">{{ task.task_title }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <span class="d-block text-h6 text-black font-weight-regular">Task Details:</span>
    <p class="mt-4 mb-10 text-md-h6 font-weight-regular project-description">
      {{ task.description }}
    </p>
    <v-row>
      <v-col cols="6" sm="12" md="12" lg="6">
        <v-row class="d-flex align-center justify-end mr-0">
          <v-btn
            v-if="!editMode"
            @click="toggleEditMode"
            fab
            small
            depressed
            color="#00B3FF"
            class="mr-2 white--text"
            sole
          >
            <v-icon>mode_edit</v-icon>
          </v-btn>
          <v-btn
            v-if="editMode"
            @click="submitTask"
            fab
            small
            depressed
            color="blue"
            class="mr-2 white--text"
            sole
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn
            v-if="editMode"
            @click="cancelChanges"
            fab
            small
            depressed
            color="gray"
            class="mr-2 white--text"
            sole
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        <v-list>
          <ListItemDateInput
            :icon="'double_arrow'"
            :label="'Task Start'"
            :selectedValue="editMode ? start_at : task.start_at"
            :edit-mode="editMode"
            @changeInput="updateTaskStartDate"
          ></ListItemDateInput>
          <ListItemDateInput
            :icon="'double_arrow'"
            :label="'Task Due'"
            :selectedValue="editMode ? due_at : task.due_at"
            :edit-mode="editMode"
            @changeInput="updateTaskDueDate"
          ></ListItemDateInput>
        </v-list>
      </v-col>
      <v-col cols="6" sm="12" md="12" lg="6">
        <v-row class="d-flex align-center justify-end mr-5">
          <v-btn
            v-if="!editMode2"
            @click="toggleEditMode2"
            fab
            small
            depressed
            color="#00B3FF"
            class="mr-2 white--text"
            sole
          >
            <v-icon>mode_edit</v-icon>
          </v-btn>
          <v-btn
            v-if="editMode2"
            @click="submitActualTime"
            fab
            small
            depressed
            color="blue"
            class="mr-2 white--text"
            sole
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn
            v-if="editMode2"
            @click="cancelChanges2"
            fab
            small
            depressed
            color="gray"
            class="mr-2 white--text"
            sole
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        <v-list>
          <ListItemNumberInput
            :icon="'double_arrow'"
            :label="`Actual Time (${this.estUnit})`"
            :value="editMode2 ? (this.actual_hours ? this.actual_hours.toString() : '') : (task.actual_hours ? task.actual_hours.toString() : '')"
            :edit-mode="editMode2"
            @input="updateActualTime"
          ></ListItemNumberInput>
          <ProfileDetailItem
            :icon="'double_arrow'"
            :label="`Est. Time (${this.estUnit})`"
            :value="task.estimated_hours ? task.estimated_hours.toString() : ''"
            :edit-mode="false"
          ></ProfileDetailItem>
        </v-list>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ProfileDetailItem from "@/components/profile/ProfileDetailItem.vue";
import ListItemDateInput from "@/components/shared/ListItemDateInput.vue";
import ListItemNumberInput from "@/components/shared/ListItemNumberInput.vue";

export default {
  components: {
    ProfileDetailItem,
    ListItemDateInput,
    ListItemNumberInput
  },
  props: {
    task: Object,
    estUnit: String,
  },
  data: () => ({
    defaultImage: require("@/assets/img/avatar.svg"),
    editMode: false,
    editMode2: false,
    errorMessage: null,
    successMessage: null,
    isSubmitting: false, 
    due_at:'',
    start_at:'',
    actual_hours:null,
  }),

  methods: {
    toggleEditMode() {
      this.start_at = this.task.start_at; 
      this.due_at = this.task.due_at; 
      this.editMode = !this.editMode;
    },
    toggleEditMode2() {
      this.actual_hours = this.task.actual_hours;
      this.editMode2 = !this.editMode2;
    },
    updateTaskStartDate(newDate) {
      this.start_at = newDate;
    },

    updateTaskDueDate(newDate) {
      this.due_at = newDate;
    },
    updateActualTime(newTime) {
      this.actual_hours = newTime;
    },
    submitTask() {
      this.isSubmitting = true;
      
      const taskData = {
        start_date: this.start_at,
        due_date: this.due_at,
      };
      this.$emit('update-task-dates', taskData);
    },
    submitActualTime() {
      this.$emit('update-actual-hours', this.actual_hours);
      this.editMode2 = false;
    },
    cancelChanges() {
      this.editMode = false;
      this.start_at = this.task.start_at;
      this.due_at = this.task.due_at;
    },
    cancelChanges2() {
      this.editMode2 = false;
      this.actual_hours = this.task.actual_hours
    },
    handleTaskDatesResponse(responseData) {
      this.isSubmitting = false; 
      
      if (responseData.error) {
        this.errorMessage = responseData.error;
        this.successMessage = null;
      } else if (responseData.success) {
        this.successMessage = responseData.success;
        this.errorMessage = null;
        this.cancelChanges();
      }
    },
  },

  created() {
    this.$parent.$on('update-task-dates', this.handleTaskDatesResponse);
  },

  destroyed() {
    this.$parent.$off('update-task-dates', this.handleTaskDatesResponse);
  },
};
</script>


<style scoped>
.text-h6 {
  font-size: 1rem;
  color: #000000;
}
.text-black {
  color: #000000;
  text-decoration: none;
}
.text-md-h5 {
  font-size: 1.25rem;
}

.text-md-h6 {
  font-size: 1rem;
}

.project-description {
  color: #999999;
}
</style>
